export default __webpack_public_path__ + "static/media/one-sample.db0cc17a.svg";